import {getSignature} from "@/Signature.js"

	import axios from 'axios';
    import isNumber from 'lodash-es/isNumber';
	import isNil from 'lodash-es/isNil';
	import isArray from 'lodash-es/isArray';
	import isFunction from 'lodash-es/isFunction';
	export const HTTP_SUCCESS_CODE = 200;
	export const HTTP_ERROR_CODE = {
	    'LOGIN_COOKIE_EXPIRE':60101,
	    'LOGIN_COOKIE_EXPIRE2':60208,
	    'LOGIN_COOKIE_EXPIRE3':60102
	};
	export const HTTP_RESPONSE_SUCCESS_CODES = [200, 0];
	function dealResData (isSingleLayerData, resData)
	{
	    if (isSingleLayerData)
	    {
	        return resData;
	    }
	    if (resData.data || resData.data === null )
	    {
	        return resData.data
	    }
	    return resData;
	};
	class HttpClient
	{
	    constructor (opt)
	    {
	        if (!isNil(opt.timeout) && !isNumber(opt.timeout))
	        {
	            throw Error('createAxios options timeout must be number');
	        }
	        if (!isNil(opt?.requestOptions?.successCodes) && !isArray(opt?.requestOptions?.successCodes))
	        {
	            throw Error('createAxios options successCodes must be array');
	        }
	        const options = Object.assign({}, {
	            'timeout': 20 * 1000,
	            'requestOptions': {
	                'isReturnNativeResponse': false,
	                'successCodes': HTTP_RESPONSE_SUCCESS_CODES,
	                'errorCodeConfig': {
	                    [HTTP_ERROR_CODE.LOGIN_COOKIE_EXPIRE] : () =>
	                    {
	                        this.toLogin();
	                    },
	                    [HTTP_ERROR_CODE.LOGIN_COOKIE_EXPIRE2] : () =>
	                    {
	                        this.toLogin();
	                    },
	                    [HTTP_ERROR_CODE.LOGIN_COOKIE_EXPIRE3] : () =>
	                    {
	                        this.toLogin();
	                    },
	                    timeoutToast: false
	                },
	                'timeoutToast':false
	            }
	        }, opt);
	        this.options = options;
	        this.axiosInstance = axios.create(options);
	        this.options?.callback?.(this.axiosInstance);
	        this.setupInterceptors();
	    }
	    toLogin ()
	    {
	        setTimeout(() =>
	        {
	            window.location.href = '/';
	        }, 3000);
	    }
	    /**
	    * @description: Set general header
	    */
	    setHeader (headers)
	    {
	        if (!this.axiosInstance)
	        {
	            return false;
	        }
	        return Object.assign(this.axiosInstance.defaults.headers, headers);
	    }
	    setupInterceptors ()
	    {
	        const { transform = {} } = this.options;
	        const {
	            requestInterceptors,
	            requestInterceptorsCatch,
	            responseInterceptors,
	            responseInterceptorsCatch
	        } = transform;
	        this.axiosInstance.interceptors.request.use(async (config) =>
	        {
	            let token = config.token ? config.token : localStorage.getItem('oauth-token');
	            if (token && config.oauth && !config.neat)
	            {
	                config.headers.Authorization = `Bearer ${token}`;
	            }
	            if(token && !config.headers.authorization && !config.neat)
	            {
	                config.headers.Authorization = `Bearer ${token}`;
	            }
	            if (requestInterceptors)
	            {
	                return requestInterceptors(config, this.options);
	            }
                if (process.realm.REALM_NODE_ENV !== 'development')
                {
                    config.headers['X-Signature'] = await getSignature();
                }
	            const {requestOptions, ...opts} = this.options;
	            return Object.assign({}, opts, config);
	        },
	        (error) =>
	        {
	            if(requestInterceptorsCatch)
	            {
	                return requestInterceptorsCatch(error);
	            }
	        });
	        this.axiosInstance.interceptors.response.use((response) =>
	        {
	            return response;
	        },
	        (error) =>
	        {
	            console.log('responseInterceptorsCatch', error);
	            if([401, 403].includes(error?.response?.status))
	            {
	                if(error?.response?.status === 401 && window.top.electronAPI)
	                {
	                    window.top.electronAPI?.send?.('web-log-out');
	                }
	                localStorage.removeItem('oauth-token');
	                sessionStorage.clear();
	            }
	            if(responseInterceptorsCatch)
	            {
	                return responseInterceptorsCatch(error);
	            }
	            return error;
	        });
	    }
	    /**
	    * @description: RESTFul接口转换,从地址拼接转换为参数
	    * @param {*} url
	    * @param {*} opts
	    * @return {*}
	    * @author: laojunpeng
	    */
	    convertRESTAPI (url, opts)
	    {
	        if (!opts || !opts.path)
	        {
	            return url;
	        }
	        const pathKeys = Object.keys(opts.path);
	        pathKeys.forEach((key) =>
	        {
	            const r = new RegExp('(:' + key + '|{' + key + '})', 'g');
	            url = url.replace(r, opts.path[key]);
	        });
	        return url;
	    }
	    getArgs (args)
	    {
	        let config = {},
	            options = {};
	        if (typeof args[0] == 'object')
	        {
	            config = args[0];
	            options = args[1] || {};
	            return { config, options };
	        }
	        else if (typeof args[0] === 'string')
	        {
	            config = { url: args[0], params: args[1] || undefined };
	            options = args[2] || {};
	            return { config, options };
	        }
	        else
	        {
	            throw new Error('Invalid first argument for HTTP');
	        }
	    }
	    get (...args)
	    {
	        const { config, options } = this.getArgs(args);
	        return this.request({ ...config, method: 'GET' }, options);
	    }
	    post (...args)
	    {
	        const { config, options } = this.getArgs(args);
	        return this.request({ ...config, method: 'POST' }, options);
	    }
	    put (...args)
	    {
	        const { config, options } = this.getArgs(args);
	        return this.request({ ...config, method: 'PUT' }, options);
	    }
	    delete (...args)
	    {
	        const { config, options } = this.getArgs(args);
	        return this.request({ ...config, method: 'DELETE' }, options);
	    }
	    async request (config,opt)
	    {
	        const options = Object.assign({}, this.options, opt);
	        const { transform = {} } = options;
	        const {
	            requestInterceptors,
	            requestInterceptorsCatch,
	            responseInterceptors,
	            responseInterceptorsCatch
	        } = transform;
	        const { isReturnNativeResponse, successCodes, errorCodeConfig, timeoutToast } = options.requestOptions;
	        const result = await this.axiosInstance.request(config);
	        if (responseInterceptors)
	        {
	            return responseInterceptors(result);
	        }
	        if (isReturnNativeResponse)
	        {
	            return result;
	        }
	        const { status, data: resData } = result;
	        if (status !== HTTP_SUCCESS_CODE)
	        {
	            if (result.stack.indexOf('timeout') > -1)
	            {
	                return Promise.reject({'message': '请求超时', 'error': result});
	            }
	            return Promise.reject({'message':`网络状态出错${status ? ',' + status : ''}`, 'error':result});
	        }
	        if (successCodes.includes(Number(resData.code)) || !resData.hasOwnProperty('code'))
	        {
	            return dealResData(options.code, resData);
	        }
	        if (errorCodeConfig && Object.keys(errorCodeConfig).includes(Number(resData.code)))
	        {
	            const handler = errorCodeConfig[resData.code];
	            if (isFunction(handler))
	            {
	                handler();
	            }
	        }
	        return Promise.reject(resData);
	    }
	}
	function isLogin()
    {
        let token = localStorage.getItem('oauth-token');
        return !!token;
    }
    function getUserInfo()
    {
        let userInfo = localStorage.getItem('userInfo');
        if (!userInfo)
        {
            let oauthToken = localStorage.getItem('oauth-token');
            const base64Data = oauthToken.split('.');
            const userData = JSON.parse(decodeURIComponent(escape(window.atob(base64Data[1].replace(/-/g, '+').replace(/_/g, '/')))));
            let candidate = userData.router_strategy?.candidate;
            userData.router_strategy.candidate = !candidate ? '' : `${candidate}/api/websocket/host_channel`;
            let discovery = userData.router_strategy?.discovery;
            userData.router_strategy.discovery = !discovery ? '' : `${discovery}/api/websocket/host_channel`;
            userInfo = JSON.stringify(userData);
            localStorage.setItem('userInfo', userInfo);
        }
        return userInfo;
    }
	function getBaseUrl(url, useUrl = 'region')
	{
	    if (process.realm.REALM_APP_PUBLISH_ENV === 'dev') return url;
	    const userInfo = getUserInfo();
	    if (useUrl === 'region')
	    {
	        return JSON.parse(userInfo).region_url + url
	    }
	    return JSON.parse(userInfo).pod_url + url;
	}
	export const hottubBaseURL = isLogin() ? process.realm.REALM_APP_HOT_TUB : '';
	export const hottubServer = new HttpClient({
	    baseURL: hottubBaseURL
	});
	export const yespmpChatBaseURL = isLogin() ? process.realm.REALM_APP_YESPMP_CHATSERVER : '';
	export const yespmpChatServer = new HttpClient({
	    baseURL: yespmpChatBaseURL
	});
	export const onecloudChatBaseURL = isLogin() ? process.realm.REALM_APP_ONECLOUD_CHATSERVER : '';
	export const onecloudChatServer = new HttpClient({
	    baseURL: onecloudChatBaseURL
	});
	export const meetingBaseURL = isLogin() ? process.realm.REALM_APP_MEETING_URL : '';
	export const meetingServer = new HttpClient({
	    baseURL: meetingBaseURL
	});
	export const shortLinkBaseURL = isLogin() ? process.realm.REALM_APP_SL_URL : '';
	export const shortLinkServer = new HttpClient({
	    baseURL: shortLinkBaseURL
	});
	export const remoteBaseURL = process.realm.REALM_APP_REMOTE;
	export const systemKeepingBaseURL = isLogin() ? getBaseUrl(process.realm.REALM_APP_SYSTEM_KEEPING, 'pod') : '';
	export const systemKeepingServer = isLogin() ? new HttpClient({
	    baseURL: systemKeepingBaseURL
	}) : null;
	export const portalBaseURL = isLogin() ? getBaseUrl(process.realm.REALM_APP_PORTAL) : '';
	export const portalServer = new HttpClient({
	    baseURL: portalBaseURL
	});
    const roseRepoRealmUrl = process.realm.REALM_APP_ROSE_REPO;
	export const roseRepoBaseURL = isLogin() ? getBaseUrl(roseRepoRealmUrl) : roseRepoRealmUrl;
	export const roseRepoServer = new HttpClient({
	    baseURL: roseRepoBaseURL
	});
	export const routerServer = new HttpClient({
	    baseURL: process.realm.REALM_APP_ROUTER_FARM
	});
	export const userServer = new HttpClient({
	    baseURL: process.realm.REALM_APP_USER
	});
	export const walletServer = new HttpClient({
	    baseURL: process.realm.REALM_APP_WALLET
	});
	export const httpbridgeServer = isLogin() ? new HttpClient({
	    baseURL: getBaseUrl(process.realm.REALM_APP_HTTPBRIDGE)
	}) : null;
	export const merchandiseServer = new HttpClient({
	    baseURL: process.realm.REALM_APP_BOBY_MERCHANDISE
	});
	export const cloudResourceServer = new HttpClient({
	    baseURL: process.realm.REALM_APP_CLOUD_RESOURCE
	});
	export const httpServer = new HttpClient({
	});
	export default new HttpClient({
	});

